import { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { adminLogin } from '../services/services';
import { useAuth } from '../Context';
import { useHistory } from 'react-router-dom';

function Login() {

	const [showAlert, setShowAlert] = useState();
	const [username, setUsername] = useState();
	const [password, setPassword] = useState();

	const history = useHistory();

	const { authUser, setAuthUser, isLoggedIn, setIsLoggedIn } = useAuth();

	const loginSubmit = (e) => {
		e.preventDefault()

		let reqBody = {
			username: username,
			password: password
		}
		adminLogin(reqBody, (response) => {
			console.log(response)
			let userdata = response.data[0]
			if(response.success){
				setIsLoggedIn(true)
				setAuthUser({
					user_id: userdata.id,
					name: userdata.name,
					phonenumber: userdata.phonenumber,
					username: userdata.username
				})
				
				history.push('/admin/clients/add')
			}else{
				setShowAlert(true)
			}
		})
	}

	return (
		<Row>
			<Col>
				<Card>
					<Card.Header as="h5">Login</Card.Header>
					<Card.Body>
						<Form onSubmit={loginSubmit}>
							<Form.Group>
								<Form.Label>Username</Form.Label>
								<Form.Control type="text" placeholder="Enter Username" value={username} onChange={(e) => setUsername(e.target.value)} />
							</Form.Group>
							<Form.Group>
								<Form.Label>Password</Form.Label>
								<Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
							</Form.Group>
							<Button variant="primary" type="submit">
								Submit
							</Button>
						</Form>
					</Card.Body>
				</Card>
			</Col>

			{showAlert ?
				<SweetAlert 
					title="Invalid Credentials."
					onConfirm={()=>setShowAlert(false)}
				/>
				:
				<></>
			}
		</Row>
	);
}

export default Login